import { Link } from "react-router-dom";

const WORK = [
  {
    num: "01",
    title: "GridScope",
    desc:
      "A resource-scheduling calendar engine built from scratch in vanilla JS as a FullCalendar replacement — drag-drop and resize, staff columns, month and list views, privacy mode and print rendering. Try the live demo.",
    tags: ["Vanilla JS", "TC39 Temporal", "Zero dependencies"],
    role: "Library author",
    meta: "Live demo · 2025",
    to: "/calendar-demo",
  },
  {
    num: "02",
    title: "E-Scaff",
    desc:
      "A scaffolding business management SaaS built for a UK client and in real-world use managing day-to-day operations — quotations, company, staff and client management, and automated PDF document generation.",
    tags: ["React", "Node.js", "MongoDB"],
    role: "Full-stack",
    meta: "Platform · Live",
    href: "https://escaff.uk",
  },
  {
    num: "03",
    title: "Turbo Bites — POS",
    desc:
      "A custom point-of-sale web app for a local fast-food chain — orders, billing and menu management, live in daily use.",
    tags: ["Vite", "Firebase"],
    role: "Full-stack",
    meta: "Product · Live",
    href: "https://turbo-bites-pos.web.app",
  },
  {
    num: "04",
    title: "IMS Portal",
    desc:
      "An inventory & survey-management system with a comprehensive dashboard, bulk actions, and reporting — built to make heavy administrative workflows feel light.",
    tags: ["React", "Express", "SQL"],
    role: "Full-stack",
    meta: "Dashboard · 2023",
  },
  {
    num: "05",
    title: "PIA Booking",
    desc:
      "An airline booking and management interface — search, fares, seat selection and admin tooling, with a focus on clarity under dense information.",
    tags: ["React", "Node.js", "PostgreSQL"],
    role: "Frontend lead",
    meta: "Product · 2023",
  },
  {
    num: "06",
    title: "Real-time Game App",
    desc:
      "An interactive gaming application with live multiplayer features, built on Canvas and WebSockets — an exercise in low-latency state and smooth rendering.",
    tags: ["JavaScript", "Canvas", "WebSocket"],
    role: "Engineer",
    meta: "Experiment · 2022",
  },
];

const STUDIES = [
  {
    title: "Netflix",
    desc: "Streaming UI with responsive layouts and live API integration.",
    st: "React · TMDB API",
  },
  {
    title: "eBay",
    desc: "Marketplace with bidding, listings and cart flows.",
    st: "React · Express · SQL",
  },
  {
    title: "LinkedIn",
    desc: "Professional network — profiles, feed and connections.",
    st: "React · Firebase",
  },
  {
    title: "Facebook",
    desc: "Full-featured social app with SSR, real-time feed, auth, posts and profiles.",
    st: "Next.js · React · Firebase",
    href: "https://fackbook.netlify.app",
  },
  {
    title: "Angular Apps",
    desc: "Multiple Angular applications covering auth, CRUD and database-driven features.",
    st: "Angular · TypeScript",
  },
  {
    title: "Django Web Apps",
    desc: "Python/Django apps with authentication, CRUD and database-driven features.",
    st: "Python · Django",
    href: "https://github.com/Abw-0l0/django_projects",
  },
  {
    title: "DSA & LeetCode",
    desc: "100+ algorithm and data-structure solutions.",
    st: "JavaScript · Python · C++",
    href: "https://github.com/Abw-0l0/leetcode",
  },
];

const Arrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M7 17L17 7M17 7H8M17 7V16" />
  </svg>
);

function Work() {
  return (
    <section className="section" id="work">
      <div className="wrap">
        <div className="section-head reveal">
          <h2 className="section-title">
            Selected <em>work</em>
          </h2>
          <p className="section-note">
            A focused set of products I've designed and built end-to-end — and a few
            studies along the way.
          </p>
        </div>

        <div className="work-list">
          {WORK.map((w) => {
            const isLink = Boolean(w.to || w.href);
            const Row = w.to ? Link : isLink ? "a" : "div";
            const target = w.to
              ? { to: w.to }
              : w.href
              ? { href: w.href, target: "_blank", rel: "noreferrer" }
              : {};
            return (
            <Row className={`work-row reveal${isLink ? "" : " static"}`} {...target} key={w.num}>
              <span className="num">{w.num}</span>
              <div className="work-main">
                <span className="work-title">{w.title}</span>
                <p className="work-desc">{w.desc}</p>
                <div className="work-tags">
                  {w.tags.map((t) => (
                    <span className="tag" key={t}>
                      {t}
                    </span>
                  ))}
                </div>
              </div>
              <div className="work-meta">
                <span className="role">{w.role}</span>
                <span>{w.meta}</span>
                {isLink && (
                  <span className="arrow">
                    <Arrow />
                  </span>
                )}
              </div>
            </Row>
            );
          })}
        </div>

        <div className="studies reveal">
          <span className="studies-label">
            Engineering studies — replications and practice repos built to master
            complex systems
          </span>
          <div className="studies-grid">
            {STUDIES.map((s) => {
              const Card = s.href ? "a" : "div";
              const link = s.href
                ? { href: s.href, target: "_blank", rel: "noreferrer" }
                : {};
              return (
                <Card className="study" key={s.title} {...link}>
                  <h4>{s.title}</h4>
                  <p>{s.desc}</p>
                  <span className="st">{s.st}</span>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Work;
